import styled from "styled-components";
import colors from "src/styles/variables.scss";
import { Button } from "antd";
import { ButtonProps } from "antd/lib/button/button";
import { ElementSize } from "src/shared/components/CustomisedShimmer";

export const shimmerConfig = [
  {
    height: "100%",
    width: "100%",
    elementSize: ElementSize.LONG,
  },
];

export const Holder = styled.section`
  display: block;
  height: auto;
  margin-bottom: 100px;
`;

export const AccordianSection = styled.ul`
  list-style: none;
  margin-top: 24px;
  padding: 0;
`;

export const FirstLevelAccordianItem = styled.li<{ open: boolean }>`
  background: ${colors.subtleGray};
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
  border: ${({ open }) => (open ? `1px solid ${colors.borderGray}` : "none")};
`;

export const FirstLevelExpandedBottom = styled.ul<{ show: boolean }>`
  list-style: none;
  padding: 0;
  height: ${({ show }) => (show ? "auto" : 0)};
  transition: height 0.1s;
  overflow: hidden;
`;

type HeaderProps = {
  open: boolean;
  barPercentage?: number;
};

export const FirstLevelHeader = styled.div<HeaderProps>`
  padding: 10px 0px 10px 15px;
  position: relative;
  border-bottom: ${({ open }) => (open ? `1px solid ${colors.borderGray}` : "none")};
  display: grid;
  grid-template-columns: auto minmax(auto, 70px) 40px;
  justify-content: stretch;
  align-items: center;
  > span {
    text-align: right;
  }
  &:after {
    content: "";
    height: ${({ open }) => (open ? "4px" : "5px")};
    background: ${colors.strongGreen};
    width: ${({ barPercentage = 100 }) => barPercentage}%;
    position: absolute;
    bottom: -1px;
    left: 0;
  }
`;

export const FirstHeaderItemName = styled.div``;

export const SecondLevelAccordianItem = styled.li<{ open?: boolean }>`
  padding: 7px 16px 3px 0;
  background: ${({ open }) => (open ? colors.spaceGray : "none")};
  &:first-of-type {
    padding-top: 16px;
  }
`;

export const SecondLevelHeader = styled.section<{ open?: boolean }>`
  display: grid;
  grid-template-columns: auto minmax(auto, 60px) 40px;
  justify-content: stretch;
  align-items: center;
  > span {
    text-align: right;
  }
`;

export const HeaderItemName = styled.p<{ barPercentage?: number }>`
  padding: 7px 16px;
  margin: 0;
  position: relative;
  z-index: 1;
  &:after {
    content: "";
    height: 100%;
    width: ${({ barPercentage = 0 }) => barPercentage}%;
    background: ${colors.gunpowderGray};
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
`;

export const SecondLevelExpandedBottom = styled.ul<{ show: boolean }>`
  list-style: none;
  padding: 0;
  height: ${({ show }) => (show ? "auto" : 0)};
  transition: height 0.1s;
  overflow: hidden;
`;

export const ThirdLevelAccordianItem = styled.li`
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > p {
    margin: 0;
    opacity: 0.5;
  }
`;

export const ButtonSection = styled.section<{ isNested?: boolean }>`
  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  grid-auto-flow: column;
  grid-gap: 15px;
  width: 100%;
  margin-bottom: 10%;
  margin-top: 20px;
  ${({ isNested }) => (isNested ? `margin: 0; padding: 11px 16px 23px 16px;` : "")}
`;

export const LoadButton: React.FunctionComponent<ButtonProps> = styled(Button)`
  letter-spacing: 0.73px;
  color: white;
  border: 1px solid ${colors.borderGray} !important;
  background: transparent !important;
  margin: 0 1%;
  border-radius: 0;
  &:focus,
  &:active {
    border-color: ${colors.borderGray};
    background: transparent;
    color: white;
  }
`;

export const NoDataText = styled.div`
  width: inherit;
  padding: 20% 0 0 0;
  display: flex;
  justify-content: center;
  opacity: 0.5;
  font-size: 1.5rem;
`;
